exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dashboardCOM-cabd9{margin-bottom:40px;padding:16px 24px;background-color:#fff}.dashboardCOM-cabd9 .container-43ef3{display:flex;justify-content:space-between}.dashboardCOM-cabd9 .container-43ef3>div{width:48%}", ""]);

// Exports
exports.locals = {
	"dashboardCOM": "dashboardCOM-cabd9",
	"container": "container-43ef3"
};